<template>
  <main class="security-rules-page">
    <section class="soft-card table-panel">
      <div class="toolbar">
        <el-input
          v-model="searchQuery"
          placeholder="搜索敏感词..."
          size="small"
          clearable
          class="search-input"
          @keyup.enter.native="onSearch"
          @clear="onSearch"
        />
        <el-button size="small" plain icon="el-icon-search" @click="onSearch">搜索</el-button>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="onAdd">新增</el-button>
      </div>
      <div class="desktop-only">
        <el-table :data="rules" size="small" style="width: 100%">
          <el-table-column type="index" label="序号" width="70" :index="pageIndex" />
          <el-table-column prop="keyword" label="敏感词" min-width="180" />
          <el-table-column prop="replacement" label="替换为" width="140" />
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.enabled === 1 ? 'success' : 'info'">{{ scope.row.enabled === 1 ? '启用' : '禁用' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="180">
            <template slot-scope="scope">{{ $formatTime(scope.row.createdAt) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="onEdit(scope.row)">编辑</el-button>
              <el-button size="small" type="text" :class="{ 'delete-btn': true, 'enable-btn': scope.row.enabled === 0 }" @click="onToggleStatus(scope.row)">
                {{ scope.row.enabled === 1 ? '禁用' : '启用' }}
              </el-button>
              <el-button size="small" type="text" class="delete-btn" @click="onDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination-bar"
          layout="total, prev, pager, next"
          small
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="onPageChange"
        />
      </div>

      <div class="mobile-only list-cards">
        <div v-for="rule in rules" :key="rule.id" class="list-card">
          <div class="card-header">
            <div class="card-title" style="font-size:14px;font-family:monospace;color:#f4b74f;">{{ rule.keyword }}</div>
            <el-tag size="small" :type="rule.enabled === 1 ? 'success' : 'info'">{{ rule.enabled === 1 ? '启用' : '禁用' }}</el-tag>
          </div>
          <div style="font-size:13px;color:rgba(255,255,255,.6);margin-bottom:8px;">
            → {{ rule.replacement }}
          </div>
          <div class="meta-row">
            <span>{{ $formatTime(rule.createdAt) }}</span>
          </div>
          <div class="card-actions">
            <el-button size="small" type="text" @click="onEdit(rule)">编辑</el-button>
            <el-button size="small" type="text" :class="{ 'delete-btn': true, 'enable-btn': rule.enabled === 0 }" @click="onToggleStatus(rule)">
              {{ rule.enabled === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button size="small" type="text" class="delete-btn" @click="onDelete(rule)">删除</el-button>
          </div>
        </div>
      </div>
    </section>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="formRules" label-width="80px" label-position="right" size="small">
        <el-form-item label="敏感词" prop="keyword">
          <el-input v-model="form.keyword" placeholder="输入要脱敏的关键词，支持正则" />
        </el-form-item>
        <el-form-item label="替换为" prop="replacement">
          <el-input v-model="form.replacement" placeholder="默认 ***" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="submitForm" size="small" :loading="submitting">确定</el-button>
      </span>
    </el-dialog>
  </main>
</template>

<script>
export default {
  name: 'SecurityRulesPage',
  data() {
    return {
      rules: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      searchQuery: '',
      dialogVisible: false,
      dialogTitle: '',
      submitting: false,
      formRules: {
        keyword: [
          { required: true, message: '请输入敏感词', trigger: 'blur' }
        ]
      },
      form: {
        id: null,
        keyword: '',
        replacement: ''
      }
    }
  },
  computed: {
    pageIndex() {
      return (this.currentPage - 1) * this.pageSize + 1
    }
  },
  mounted() {
    this.fetchRules()
  },
  methods: {
    async fetchRules() {
      try {
        const res = await this.$http.get('/admin/security-rules', {
          params: {
            keyword: this.searchQuery || undefined,
            page: this.currentPage,
            pageSize: this.pageSize
          }
        })
        this.rules = res.records || []
        this.total = Number(res.total) || 0
      } catch {
        this.$message.error('加载脱敏规则失败')
      }
    },
    onPageChange(page) {
      this.currentPage = page
      this.fetchRules()
    },
    onSearch() {
      this.currentPage = 1
      this.fetchRules()
    },
    onAdd() {
      this.dialogTitle = '新增脱敏规则'
      this.form = { id: null, keyword: '', replacement: '' }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form?.clearValidate())
    },
    onEdit(row) {
      this.dialogTitle = '编辑脱敏规则'
      this.form = {
        id: row.id,
        keyword: row.keyword,
        replacement: row.replacement || ''
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form?.clearValidate())
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          const data = {
            keyword: this.form.keyword,
            replacement: this.form.replacement || undefined
          }
          if (this.form.id) {
            await this.$http.put('/admin/security-rules/' + this.form.id, data)
            this.$message.success('编辑成功')
          } else {
            await this.$http.post('/admin/security-rules', data)
            this.$message.success('新增成功')
          }
          this.dialogVisible = false
          this.fetchRules()
        } catch {
          this.$message.error('操作失败')
        } finally {
          this.submitting = false
        }
      })
    },
    onDelete(row) {
      this.$confirm('确定删除敏感词「' + row.keyword + '」？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return this.$http.delete('/admin/security-rules/' + row.id)
      }).then(() => {
        this.$message.success('删除成功')
        this.fetchRules()
      }).catch(() => {})
    },
    async onToggleStatus(row) {
      const newVal = row.enabled === 1 ? 0 : 1
      try {
        await this.$http.put('/admin/security-rules/' + row.id, {
          keyword: row.keyword,
          replacement: row.replacement || undefined,
          enabled: newVal
        })
        row.enabled = newVal
        this.$message.success((newVal === 1 ? '启用' : '禁用') + '成功')
      } catch {
        this.$message.error('操作失败')
      }
    }
  }
}
</script>

<style scoped>
.security-rules-page {
  padding: 18px 24px 76px;
}

.table-panel {
  padding: 16px;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.table-panel ::v-deep .el-table,
.table-panel ::v-deep .el-table__header-wrapper,
.table-panel ::v-deep .el-table__body-wrapper {
  border-radius: var(--radius);
}

.table-panel ::v-deep th {
  background: rgba(255, 255, 255, 0.045);
  color: #9eb1ca;
  font-weight: 850;
}

.table-panel ::v-deep td,
.table-panel ::v-deep th {
  border-color: var(--line-soft);
}

.pagination-bar {
  margin-top: 20px;
  text-align: right;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
}

.search-input {
  width: 200px;
}

.delete-btn {
  color: #e74c3c;
}

.enable-btn {
  color: #67c23a;
}

.list-cards { display: grid; gap: 14px; }

.mobile-only { display: none; }

@media (max-width: 760px) {
  .desktop-only { display: none; }
  .mobile-only { display: block; }
  .security-rules-page {
    padding: 12px 12px 28px;
  }
  .table-panel {
    padding: 10px;
    overflow-x: visible;
  }
  .toolbar {
    flex-wrap: wrap;
  }
  .search-input {
    flex: 1;
    min-width: 80px;
  }
  .pagination-bar {
    text-align: center;
  }
}
/* Card redesign */
.list-card {
  padding: 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(27,39,58,.92), rgba(20,30,46,.88));
  border: 1px solid rgba(133,164,255,.12);
  box-shadow: 0 8px 28px rgba(0,0,0,.22);
  overflow: hidden;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 8px;
}
.card-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text);
  line-height: 1.3;
}
.card-sub {
  font-size: 12px;
  color: rgba(255,255,255,.4);
  margin-top: 2px;
}
.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(133,164,255,0.06);
  margin-top: 6px;
  font-size: 11px;
  color: rgba(255,255,255,.35);
}
.card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-top: 10px;
  border-top: 1px solid rgba(133,164,255,0.06);
  margin-top: 6px;
}
.card-actions .el-button--text {
  font-size: 12px;
  padding: 4px 10px;
  height: auto;
}
</style>
